/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForFinOpsAiOntologySyncAdhoc extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForFinOpsAiOntologySyncAdhoc");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForFinOpsAiOntologySyncAdhoc.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForFinOpsAiOntologySyncAdhoc>): BackgroundJobPayloadForFinOpsAiOntologySyncAdhoc {
        let obj = Object.assign(new BackgroundJobPayloadForFinOpsAiOntologySyncAdhoc(), model);
        BackgroundJobPayloadForFinOpsAiOntologySyncAdhoc.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForFinOpsAiOntologySyncAdhoc>): BackgroundJobPayloadForFinOpsAiOntologySyncAdhoc {
        if (!model) return null;
        return BackgroundJobPayloadForFinOpsAiOntologySyncAdhoc.newInstance(<BackgroundJobPayloadForFinOpsAiOntologySyncAdhoc> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForFinOpsAiOntologySyncAdhoc) {
        if (!obj) return;

        models.BackgroundJobPayloadForFinOpsAiOntologySyncAdhoc.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForFinOpsAiOntologySyncAdhoc): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForFinOpsAiOntologySyncAdhoc.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
